import * as React from "react";

import { cn } from "@/lib/utils";

export type TextareaProps = React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        className={cn(
          "text-ui-body-sm flex min-h-[80px] w-full rounded-lg border border-input bg-card px-3 py-2 ring-offset-background outline-none placeholder:text-muted-foreground transition-all duration-200 hover:border-blueprint-heavy/20 focus-visible:ring-3 focus-visible:ring-blueprint-heavy/20 focus-visible:border-blueprint-heavy disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:hover:border-destructive aria-invalid:focus-visible:ring-4 aria-invalid:focus-visible:ring-destructive/20 aria-invalid:focus-visible:border-destructive",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Textarea.displayName = "Textarea";

export { Textarea };
